import FlickitySlider from "./flickity";

export default class Sliders {
	constructor() {
		this.sliders = [];
		this.init();
	}

	init() {
		window.FlickitySliders = [];
		Array.prototype.slice
			.call(document.querySelectorAll(".flickity-slideshow"))
			.forEach((slider) =>
				this.sliders.push(
					new FlickitySlider(slider, slider.dataset.options || null)
				)
			);
	}

	destroy() {
		console.log("called: sliders destroy()");
		this.sliders.forEach((slider) => slider.destroy());
	}
}
